module.exports = __webpack_public_path__ + "static/construction-34e9b3817009973cb2449e94aa6fa75d.jpg";